module.exports = __webpack_public_path__ + "static/media/work2.bcda33bf.png";